import { Component, OnInit, ViewChild,Input, SimpleChanges } from '@angular/core';
import { AutomationService } from '../automation.service';
import { AutomationExporterService } from '../automation-exporter.service';
import { CloudFolderContentComponent } from '../cloud-folder-content/cloud-folder-content.component';
import { ListRootContainersComponent } from '../list-root-containers/list-root-containers.component';

@Component({
  selector: 'app-exporter',
  templateUrl: './exporter-s3.component.html',
  styleUrls: ['./exporter-s3.component.css']
})
export class ExporterS3Component implements OnInit  {

  @ViewChild('selectInputMap') selectInputMap: CloudFolderContentComponent;
  @ViewChild('selectCompanyFolder') selectCompanyFolder: CloudFolderContentComponent;
  @ViewChild('selectOutputFolder') selectOutputFolder: CloudFolderContentComponent;
  @ViewChild('listRootContainer') listRootContainer: ListRootContainersComponent;

  //cloud workitem parameters
  inputMap;// = "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Input/all.hmm";
  companyFolder;//  = "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Input/ServerCompany.zip";
  outputFolder;// = "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Output/output.zip";

  //activity commandline parameters
  mode;//= 'Group';
  exporter;// = 'ServerGroup';
  bucket;//="iohsbsharebucket";
  _bucketLastValue;

  accessKeyId = "AKIAIMVKNEIZGS4LP7KQ";
  secretAccessKey = "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";
  _lastaccessKeyId;
  _lastsecretAccessKey;

  showSpinner = false;
  resultHeader = "";
  result = "";

  constructor(private automationService: AutomationService,
              private automationExporterService: AutomationExporterService) { }

  ngOnInit() {
    
    //this.selectInputMap.selectS3Link(this.accessKeyId, this.secretAccessKey, "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Input/all.hmm");
    //this.selectCompanyFolder.selectS3Link(this.accessKeyId, this.secretAccessKey, "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Input/ServerCompany.zip");
    //this.selectOutputFolder.selectS3Link(this.accessKeyId, this.secretAccessKey, "https://iohsbsharebucket.s3.amazonaws.com/Exporter/Output/output.zip");

    //this.selectInputMap.list(this.accessKeyId, this.secretAccessKey, 'iohsbsharebucket', '/');
    //this.selectCompanyFolder.list(this.accessKeyId, this.secretAccessKey, 'iohsbsharebucket', '/');
    //this.selectOutputFolder.list(this.accessKeyId, this.secretAccessKey, 'iohsbsharebucket', '/');
    this.passwordUpdated();

  }

  // ngDoCheck() {}
  onRootContainerChanged(rootContainerValue){
    this.bucket = rootContainerValue.Name;

    if(this.bucket != this._bucketLastValue)
    {
      this.updateFolderControls();
      this._bucketLastValue = this.bucket;
    }
  }
  resetStorageProviderFieldInputs(){
    this.inputMap = '';
    this.companyFolder='';
    this.outputFolder='';
  }
  updateFolderControls(){
    if(!this.bucket || this.bucket === ''){
      return;
    }
    this.selectInputMap.listS3(this.accessKeyId, this.secretAccessKey, this.bucket, '/');
    this.selectCompanyFolder.listS3(this.accessKeyId, this.secretAccessKey, this.bucket, '/');
    this.selectOutputFolder.listS3(this.accessKeyId, this.secretAccessKey, this.bucket, '/');
  }
  passwordUpdated(){
    if(this.accessKeyId != this._lastaccessKeyId || 
      this.secretAccessKey != this._lastsecretAccessKey)
   {

       this.listRootContainer.listRootContainersS3(this.accessKeyId, this.secretAccessKey)
        .then(res => {
          this._lastsecretAccessKey = this.secretAccessKey;
          this._lastaccessKeyId = this.accessKeyId;
          this.updateFolderControls();
          this.resetStorageProviderFieldInputs();
          this.listRootContainer.clearText();
        }, error => {
          console.log('Error listing containers s3: ' + error);
        });
   }
  }
 

  inputMapChanged(e){
    this.inputMap = e.selectedFileURL;
  }
  companyFolderChanged(e){
    this.companyFolder = e.selectedFileURL;
  }
  selectOutputFolderChanged(e){
    this.outputFolder = e.selectedFileURL;
  }

  run(){

    this.result = ""
    this.resultHeader = "";
    this.showSpinner = true;

    let executionContext = this.automationExporterService.
                            getExecutionContextDefaultCopyS3(this.inputMap,
                              this.companyFolder,
                              this.outputFolder,
                              this.accessKeyId,
                              this.secretAccessKey);

    this.automationExporterService.updateCommandLineParameters(executionContext, 
                                                                this.mode,
                                                                this.exporter);                        

    this.automationService.executeContext(executionContext)
      .then(result => {
          this.showSpinner = false;
          if(Array.isArray(result) && result.length > 0){
              var resText = result[0].replace("Upload Success:", "");
              this.resultHeader = "Exporter finised executing. Output zipped folder uploaded to: " ;
              this.result = resText;
          }else{
            this.resultHeader = "There was an error executing exporter: ";
            this.result = JSON.stringify(result);
          }
      }, error => {
          this.showSpinner = false;
          this.resultHeader = "There was an error executing exporter: ";
          this.result = JSON.stringify(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/exporter-s3/exporter-s3.component.ts